export default __webpack_public_path__ + "static/media/border-vertical-1.e7b898ae.webp";